export const selectImages = (state) => state.images;
export const selectEncounters = (state) => state.encounters.encounterList;
export const selectEncounterDetails = (state) => state.encounters.encounterDetails;
